import { render, staticRenderFns } from "./SwiperSlide.vue?vue&type=template&id=8fe16c12&scoped=true"
import script from "./SwiperSlide.vue?vue&type=script&lang=js"
export * from "./SwiperSlide.vue?vue&type=script&lang=js"
import style0 from "./SwiperSlide.vue?vue&type=style&index=0&id=8fe16c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe16c12",
  null
  
)

export default component.exports